async function readBulkResponse(response) {
  if (!response.ok) throw new Error('Could not save the test. Please try again.')
  return response.json()
}
function bulkNotice(result) {
  if (result.warning) return result.warning
  if (result.conflicts && result.conflicts.length) return `Saved. These products are paused because another active test is using them: ${result.conflicts.slice(0, 10).map(item => item.title).join(', ') + (result.conflicts.length > 10 ? ` and ${result.conflicts.length - 10} more` : '')}. Pause the conflicting tests before resuming these products.`
  return result.status === 'paused' ? 'Saved as paused. Your products are not running.' : 'Saved'
}
module.exports = { readBulkResponse, bulkNotice }
